<script setup>
import { defineProps, defineEmits, onMounted, ref } from 'vue'
import { Gems } from '@/gems'
// import { KNOLIA } from '@/knolia'

const emits = defineEmits(['toggle-childs'])

const props = defineProps({
    element: {
      type: Object,
      default: Object
    },
    mobileView: Boolean
})

// const showTrainingReqInput = ref(false)
const elementType = ref('')

// function GetTrainingRequestId(id) {
//     const type = props.element.is_activity ? 'activity' : props.element.is_task ? 'task' : 'skill'
//     return `training-${type}-${id}`
// }

// async function SendTrainingRequest(id, elem) {
//     const request = document.getElementById(GetTrainingRequestId(id))

//     KNOLIA.CallBackEnd('post', 'set-operations&get=send-training-request',
//         {
//             params: {
//                 request: request.value,
//                 elem
//             }
//         }
//     );

//     request.value = null
// }

// function GapStyle(gap) {
//     if(gap >= 100)
//         return 'div-no-gap'

//     if(gap == 0)
//         return 'div-full-gap'

//     return ''
// }

onMounted(() => {
    elementType.value = props.element.is_activity ? 'Atividade' : props.element.is_task ? 'Tarefa' : 'Competência operativa'
})
</script>

<template>
    <div class="div-row-text"> 
        <div class="cursor-default" @mouseenter="Gems.TooltipIfNeeded($event.target)">
            <span class="cursor-pointer line-clamp line-clamp-1" @mouseenter="Gems.Tooltip($event.target, elementType, 'tooltip')">
                {{ element.designation }}
            </span>
        </div>

        <div class="div-gaps-container">
            <div class="div-gaps-inner-container cursor-default" v-if="element.is_activity || element.is_task" :class="{'gap-mobile': mobileView}">
                <div class="div-gap" @mouseenter="Gems.Tooltip($event.target, 'Proficiência detida face ao Padrão', 'tooltip')">{{ element.rating_desc ?? '--' }}</div>
            </div>
            
            <div  v-else class="cursor-default" @mouseenter="Gems.Tooltip($event.target, 'Classificação da proficiência', 'tooltip')">
                {{ element.proficiency_desig ?? '--'}}
            </div>

            <!-- <div class="div-training-requests" :class="{ 'flex-1': showTrainingReqInput }">
                <input :id="GetTrainingRequestId(element.id)" class="input-training-request" type="text"
                    maxlength="255" v-if="showTrainingReqInput">
                
                <i class="fa fa-check cursor-pointer" v-if="showTrainingReqInput"
                    @click="SendTrainingRequest(element.id, element)" @mouseenter="Gems.Tooltip($event.target, 'Gravar', 'tooltip')"></i>

                <i id="fa-users-rectangle" class="fas fa-users-rectangle cursor-pointer show-icon" v-if="!showTrainingReqInput"
                    @click="showTrainingReqInput = !showTrainingReqInput" @mouseenter="Gems.Tooltip($event.target, 'Pedido de formação', 'tooltip')"></i>
                
                <i id="fa-xmark" class="fas fa-xmark cursor-pointer show-icon" v-if="showTrainingReqInput"
                    @click="showTrainingReqInput = !showTrainingReqInput" @mouseenter="Gems.Tooltip($event.target, 'Cancelar', 'tooltip')"></i>
            </div> -->
            <i class="fas cursor-pointer i-chevron" @click="emits('toggle-childs', element)"
                :class="{ 'fa-chevron-down': !element.show, 'fa-chevron-up': element.show, 'chevron-hidden': !((element.is_task || element.is_activity) && element.children.length > 0) }"></i>
        </div>
    </div>
</template>

<style scoped>
    .div-row-text {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 5px;
        justify-content: space-between;
    }

    .div-training-requests {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
    }

    .input-training-request {
        padding: 4px 3px;
        width: -webkit-fill-available;
    }

    .div-training-requests i {
        font-size: 1.2em;
    }

    .fa-check {
        margin-left: 10px;
    }

    .fa-xmark {
        margin-left: 10px;
        margin-right: 10px;
    }

    .div-training-requests i:hover {
        color: var(--default-app-hover-color)
    }

    .fa-users-rectangle {
        margin-right: 10px;
    }

    .div-gaps-inner-container {
        display: flex;
        flex-direction: row;
        align-self: center;
        justify-content: space-evenly;
    }

    .div-gaps-container {
        display: flex;
        justify-content: flex-end;
        flex: 1;
        align-items: center;
    }

    .gap-mobile {
        font-size: .9em;
    }

    .div-gap {
        width: 250px;
    }

    .div-gap:nth-child(1) {
        text-align: end;
    }

    .div-gap:nth-child(1) {
        text-align: end;
    }

    .div-no-gap {
        color: greenyellow;
    }

    .div-full-gap {
        color: #ff7500;
    }

    .span-proficiency {
        font-size: 1.2em;
    }

    .flex-1 {
        flex: 1;
    }

    .i-chevron {
        padding-left: 9px;
    }

    .chevron-hidden {
        pointer-events: none;
        opacity: 0;
    }

</style>